import styled from "@emotion/styled";
import { Tooltip, Typography } from "antd";

export const StyledTooltip = styled(Tooltip)``;

export const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledText = styled(Typography.Text)<{ color }>`
    color: ${(props) => props.color};
`;
